function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var L = Object.defineProperty;
var t = Object.getOwnPropertySymbols;
var r = Object.prototype.hasOwnProperty,
    d = Object.prototype.propertyIsEnumerable;

var C = function C(o, e, l) {
  return e in o ? L(o, e, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: l
  }) : o[e] = l;
},
    n = function n(o, e) {
  for (var l in e || (e = {})) {
    r.call(e, l) && C(o, l, e[l]);
  }

  if (t) {
    var _iterator = _createForOfIteratorHelper(t(e)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var l = _step.value;
        d.call(e, l) && C(o, l, e[l]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return o;
};

import * as i from "react";

function v(o) {
  return i.createElement("svg", n({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, o), i.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.46 8.29L12 5.83L9.53001 8.29C9.14001 8.68 8.51001 8.68 8.12001 8.29C7.73001 7.9 7.73001 7.27 8.12001 6.88L11.29 3.7C11.68 3.31 12.31 3.31 12.7 3.7L15.87 6.88C16.26 7.27 16.26 7.9 15.87 8.29C15.48 8.68 14.85 8.68 14.46 8.29ZM9.54001 15.71L12 18.17L14.47 15.72C14.86 15.33 15.49 15.33 15.88 15.72C16.27 16.11 16.27 16.74 15.88 17.13L12.71 20.3C12.32 20.69 11.69 20.69 11.3 20.3L8.13001 17.12C7.74001 16.73 7.74001 16.1 8.13001 15.71C8.52001 15.32 9.15001 15.32 9.54001 15.71Z",
    fill: "black"
  }));
}

export { v as ReactComponent };